import { render, staticRenderFns } from "./fieldlist.vue?vue&type=template&id=fded89b2&scoped=true"
import script from "./fieldlist.vue?vue&type=script&lang=js"
export * from "./fieldlist.vue?vue&type=script&lang=js"
import style0 from "./fieldlist.vue?vue&type=style&index=0&id=fded89b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fded89b2",
  null
  
)

export default component.exports